import {
  useMutation,
  UseMutationOptions,
  useQuery,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import api from "axios.config";

import {
  ProductDetailsSuccess,
  ProductEditParams,
  ProductEditSuccess,
  ProductsOverviewParams,
  ProductsOverviewSuccess,
} from "./types/products.type";

export const useProductsOverview = (params: ProductsOverviewParams) =>
  useQuery<ProductsOverviewSuccess, AxiosError<GlobalErrorResponse>>({
    queryKey: ["products-overview", params],
    queryFn: async ({ signal }) =>
      api
        .get(`${process.env.REACT_APP_API_GET_ONLINE_PRODUCT_DETAILS}`, {
          params,
          signal,
        })
        .then((r) => r.data),
    // Removed keepPreviousData for faster refresh
    staleTime: 0, // Always consider data stale for immediate refresh
    refetchOnWindowFocus: false, // Do not reload on simple focus changes without clickable actions
  });

export const useProductDetails = (id: string) =>
  useQuery<ProductDetailsSuccess, AxiosError<GlobalErrorResponse>>({
    queryKey: ["product-details", id],
    queryFn: async ({ signal }) =>
      api
        .get(`${process.env.REACT_APP_API_VIEW_ONLINE_PRODUCT_DETAILS}/${id}`, {
          signal,
        })
        .then((r) => r.data),
    enabled: !!id,
  });

export const useEditProduct = (
  options?: UseMutationOptions<
    ProductEditSuccess,
    AxiosError<GlobalErrorResponse>,
    ProductEditParams
  >
) => {
  return useMutation({
    mutationFn: async (data) =>
      api
        .post(`${process.env.REACT_APP_API_EDIT_ONLINE_PRODUCT_DETAILS}`, data)
        .then((r) => r.data),
    ...options,
  });
};
